import { MenuItem, Select } from '@mui/material';
import { Building } from '../@types/model/user';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { buildingState, getBuildings } from 'recoil/buildingState';

interface BuildingPickerProps {
  buildingGuid: string | undefined;
  changeHandler: (buildingGuid: string | null) => void;
  addEmptyValue: boolean;
}

const BuildingPicker = (props: BuildingPickerProps) => {
  const { t } = useTranslation();
  const buildings: Building[] = useRecoilValue(buildingState);
  const setBuildings = useSetRecoilState(buildingState);

  useEffect(() => {
    getBuildings().then((buildings: Building[]) => {
      setBuildings(buildings);
    });
  }, []);

  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={props.buildingGuid}
      label={t('building')}
      onChange={(event) => props.changeHandler(event.target.value)}
    >
      {props.addEmptyValue ? <MenuItem value={''}>{'-'}</MenuItem> : null}
      {buildings.map((b: Building) => {
        return (
          <MenuItem key={b.guid} value={b.guid}>
            {b.attributes.name}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default BuildingPicker;
